import React, { Component } from "react";
import ProductosHeaderMod from './productos_header_mod'


class ProductoHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
		};
	}

	componentDidMount() {
		//this.setState({ activeIndex: 0 });
	}

	componentDidUpdate(prevProps, prevState) {
		console.log(this.state)
	}

	render() {

		if (!this.props.productos) {
			return <div>CARGANDO</div>;
		}
		const listaProductosHead = this.props.productos.map((producto, i) => {
			var estado = "";
			if (i === 0) {
				estado = "active";
			}
			return <ProductosHeaderMod key={i} producto={producto} ubicacion={this.props.ubicacion} estado={estado} />;
		});

		const listaIndicators = this.props.productos.map((producto, i) => {
			var estado = "";
			if (i == 0) {
				estado = "active";
			}
			return <li data-target="#carouselExampleIndicators" className={estado} data-slide-to={i}  key={i}></li>;
		});

		return (
			<div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel" data-interval="3000" data-wrap="true">
				
				<ol className="carousel-indicators">{listaIndicators}</ol>
				<div className="carousel-inner headColor">{listaProductosHead}</div>

				<a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
					<span className="carousel-control-prev-icon" aria-hidden="true"></span>
					<span className="sr-only">Ant</span>
				</a>
				<a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
					<span className="carousel-control-next-icon" aria-hidden="true"></span>
					<span className="sr-only">Prox</span>
				</a>
				
				<img src="https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/imgs%2Fsomosfabricantes.png?alt=media" className="somos_fab_label" />
			</div>
		);
	}
}

export default ProductoHeader;



// WEBPACK FOOTER //
// ./src/components/productoheader.js